import Api from '@/config/api';
import request from '@/utils/request'
export default {
  // appdownload
  appdownload: ({ payload, ...props }) => {
    return request(Api.appdownload, { body: payload, ...props })
  },
  ip_limit: ({ payload, ...props }) => {
    return request(Api.ip_limit, { body: payload, ...props })
  },

}